<template>
    <div class="dropdown-input-wrapper">
        <div class="select-container relative">
            <select 
                :id="id" 
                v-model="internalValue" 
                :disabled="!enabled" 
                :required="field.required" 
                class="select-input text-base text-[var(--charcoal-dark)] border border-[var(--bone)] focus:border-[var(--primary)] rounded-full h-9 px-3 py-1 pr-10 bg-white w-full outline-0 appearance-none"
                :class="{ 'input-error': display_errors && error, 'input-disabled': !enabled, 'has-value': internalValue }"
                @change="$emit('update:value', internalValue); $emit('validate')" 
                :aria-describedby="errorId"
            >
                <option value="" disabled>{{ field.placeholder || 'Select an option' }}</option>
                <option v-for="option in field.options" :key="option.id" :value="option.value">
                    {{ option.label }}
                    <template v-if="option.additional_fee && option.price"> (+${{ option.price }}{{ perPersonSuffix }})</template>
                </option>
            </select>
            <div class="select-icon w-5 h-5 absolute right-4 top-1/2 -translate-y-1/2">
                <svg class="max-w-full" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 9l4-4 4 4m0 6l-4 4-4-4" />
                </svg>
            </div>
        </div>
        <div v-if="display_errors && error" class="error-message flex items-center text-sm text-[var(--error)]" :id="errorId">
            <svg class="max-w-full mr-2 w-5 h-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            {{ error }}
        </div>
    </div>
</template>

<script>
export default {
    props: {
        field: { type: Object, required: true },
        value: { type: [String, null], default: null },
        enabled: { type: Boolean, default: true },
        display_errors: { type: Boolean, default: false },
        error: { type: String, default: '' },
        idSuffix: { type: String, default: '' }
    },
    computed: {
        id() { return `field-${this.field.id}${this.idSuffix}`; },
        errorId() { return `error-field-${this.field.id}${this.idSuffix}`; },
        // display_once price_per_pax fields are answered once but priced per
        // traveler — flag that in the option label so it's not mistaken for a flat fee.
        perPersonSuffix() {
            return (this.field.unit_type === 'price_per_pax' && !!this.field.display_once) ? '/person' : '';
        },
        internalValue: {
            get() { return this.value; },
            set(newValue) { this.$emit('update:value', newValue); }
        }
    }
};
</script>
